import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../RootState";

export const selectBrokerConfigurationState = createSelector(
    (state: RootState) => state.brokerConfiguration,
    (state) => state

)